import { defineSlotRecipe } from '@chakra-ui/react';

export const listingLayoutSlotRecipe = defineSlotRecipe({
    slots: [
        'actionBar',
        'activeFilters',
        'breadcrumbs',
        'filtersInfoBox',
        'headingWrapper',
        'pageHeading',
        'searchbar',
        'searchResultsWrapper',
        'sidebar',
        'description',
        'descriptionButton',
        'descriptionTitle',
    ],
    base: {
        actionBar: {
            borderBottom: '1px solid',
            justifyContent: 'space-between',
            gap: 4,
            pb: 2,
            h: 10,
            display: {
                base: 'flex',
                md: 'none',
            },
        },
        searchbar: {
            order: {
                base: 1,
                md: 0,
            },
            position: 'sticky',
            top: 0,
            zIndex: { base: 'sticky', md: 'modal' },
            bg: 'white',
            pt: 2,
            pb: {
                base: 0,
                md: 2,
            },
            mt: {
                base: 2,
                lg: 4,
            },
            mb: {
                base: 3,
                lg: 4,
            },
            px: {
                base: 'gutterWidth',
                md: 'gutterWidthDesktop',
            },
            transition: 'all 0.2s ease',
        },
        breadcrumbs: {
            maxW: 'containerWidth',
            px: {
                base: 'gutterWidth',
                md: 'gutterWidthDesktop',
            },
            mx: 'auto',
            mb: {
                base: 2,
                md: 6,
            },
            mt: {
                base: 4,
                md: 0,
            },
        },
        sidebar: {
            display: {
                base: 'none',
                lg2: 'block',
            },
        },
        searchResultsWrapper: {
            position: 'relative',
        },
        headingWrapper: {
            justifyContent: 'space-between',
            mb: { base: 1, md: 2 },
        },
        pageHeading: {
            flex: '1 1 auto',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            '& h1': {
                fontWeight: '600',
                fontSize: 'sm',
                lineClamp: 1,
                mr: 4,
            },
            '& span': {
                whiteSpace: 'nowrap',
                fontSize: 'sm',
            },
            md: {
                flexDirection: 'column',
                alignItems: 'start',
                justifyContent: 'flex-start',
                '& h1': {
                    fontWeight: 'bold',
                    fontSize: '3xl',
                    lineClamp: 'unset',
                },
                '& span': {
                    fontSize: 'md',
                },
            },
        },
        activeFilters: {
            display: {
                base: 'none',
                md: 'block',
            },
        },
        filtersInfoBox: {
            py: {
                base: 2,
                md: 3,
            },
            px: 4,
            mb: 4,
            borderRadius: 'md',
            boxShadow: 'tile',
            fontSize: {
                base: 'xs',
                md: 'md',
            },
            '& span': {
                alignItems: 'center',
                justifyContent: 'center',
                h: 8,
                w: 8,
                border: '1px solid',
                borderColor: 'secondary.600',
                borderRadius: 'full',
                '& svg': {
                    color: 'secondary.600',
                    rotate: '90deg',
                    mr: 1,
                    mt: 1,
                },
            },
            '& em': {
                fontSize: 'md',
                fontWeight: {
                    base: 'bold',
                    md: 'normal',
                },
                color: {
                    base: 'secondary.600',
                    md: 'gray.900',
                },
            },
        },
        description: {
            py: {
                base: 2,
                md: 3,
            },
            px: 4,
            mb: 4,
            borderRadius: 'md',
            boxShadow: 'tile',
        },
        descriptionTitle: {
            fontSize: 'xl',
            fontWeight: 'bold',
            mb: 4,
        },
        descriptionButton: {
            display: 'block',
            fontWeight: 'bold',
            mt: 2,
            ml: 'auto',
        },
    },
});
